import { render } from "./AnchorMenuComp.vue?vue&type=template&id=0a525b44&scoped=true&ts=true"
import script from "./AnchorMenuComp.vue?vue&type=script&lang=ts"
export * from "./AnchorMenuComp.vue?vue&type=script&lang=ts"

import "./AnchorMenuComp.vue?vue&type=style&index=0&id=0a525b44&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\user\\Documents\\Code\\VSProjects\\modboxProject\\modbox\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a525b44"]])

export default __exports__